import { Language } from "@whoppah/apollo/schema";

import { type ContentLocale, toContentLocale } from "@/i18n/config";

const LANGUAGE_MAP: Record<ContentLocale, Language> = {
  en: Language.En,
  nl: Language.Nl,
  de: Language.De,
  fr: Language.Fr,
  es: Language.Es,
  it: Language.It,
};

const LanguageUtils = {
  /** The gateway's `Language` for a routed locale; `en-us` reads `en` (WHO-5766). */
  getLanguage: (locale: string | undefined) => {
    return LANGUAGE_MAP[toContentLocale(locale)];
  },
};

export default LanguageUtils;
